<div class="fundraising-container">

    <ngx-spinner
      bdColor="rgba(75, 55, 100, 0.5)"
      size="large"
      color="#fff"
      type="line-scale-pulse-out">
          <span class="chevron left"></span>
          <span class="chevron right"></span>
    </ngx-spinner>

      <div class="search-row align-center">
        <button style="box-shadow: 0 3px 15px 6px rgba(120, 99, 225, 0.22);" class="btn dark-btn" (click)="create()">
          New Team
        </button>
       <div class="input-with-icon align-row">
          <div class="input-icon align-center"><i class="flaticon-search"></i></div>
          <input
            type="text"
            placeholder="Search"
            (keyup)="search()"
            [(ngModel)]="searchText"
            class="searchtext"
        />
        </div>
      </div>
      <div *ngIf="teams" class="fundraising-table">
        <div class="data-row" *ngFor="let team of displayItems">
          <div class="data-row-content" style="height: 100%;">
            <div class="content-cell" style="justify-content: space-between;">
              <div style="justify-content: space-between;" class="cell-row">
                <h3 class="fundraiser-title">{{team.name}}</h3>
                <div class="dropdown">
                  <div class="dots">
                    <img/>
                  </div>
                  <div class="dropdown-content">
                    <a (click)="edit(team.teamId)" href="#">Edit</a>
                  </div>
                </div>
              </div>
              <div class="cell-row" style="flex-direction: column;">
                <div>
                  <div class="logo-container">
                    <img
                        *ngIf="team.logoUrl !== ''"
                        alt="" [src]="team.logoUrl" style="display: block; margin: auto;">
                  </div>
                </div>
              </div>
              <div class="cell-row">
                <div class="info-container" style="width: 100%">
                  <span class="info-content">{{team.sport}}</span>
                  <span class="info-title">Sport</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!displayItems.length"> No teams to show, click 'New Team' to begin</div>
      </div>
    </div>
